import NewActivityTool from "./components/newactivitytool";

export default function Personal() {
  return (
    <>
      <NewActivityTool />
    </>
  );
}
